import { Component, OnInit } from '@angular/core';
import { ApiService } from '../services/api.service';

@Component({
  selector: 'app-reset-db',
  templateUrl: './reset-db.component.html',
  styleUrls: ['./reset-db.component.scss']
})
export class ResetDBComponent implements OnInit {
  result = ''

  constructor(private apiService: ApiService) { }

  ngOnInit(): void {
    this.apiService.resetDB()
      .then(
        result => this.result = result,
        _ => this.result = "Failed to reset database.");
  }
}
